import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

const strokeProps = {
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

export const EloLiveIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <circle cx='10' cy='10' r='1.75' {...strokeProps} />
    <path d='M6.46 13.54C4.51 11.59 4.51 8.41 6.46 6.46' {...strokeProps} />
    <path d='M13.54 6.46C15.49 8.41 15.49 11.59 13.54 13.54' {...strokeProps} />
    <path d='M4.11 15.89C0.86 12.64 0.86 7.36 4.11 4.11' {...strokeProps} />
    <path d='M15.89 4.11C19.14 7.36 19.14 12.64 15.89 15.89' {...strokeProps} />
  </EloBaseIcon>
)
